export interface SalesDespatchItemForOrder {
  id: string;
  stockNo: string;
  orderNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  despatchNoteNo: number;
  despatchDate: Date;
  trackingNo: string;
  invoiceNo: number;
  invoiceDate: Date;
  invoiceFromPicking: boolean;
  currency: string;
}
